import React from 'react'
import { Modal, message } from 'antd'
import { RedoOutlined } from '@ant-design/icons'
import { postRequest, dutyBroadcastRetryRecipientsUrl } from '../../../config'

/**
 * Confirm, then requeue failed recipients of a broadcast.
 *
 * `recipientIds` null/omitted → every failed recipient; an array → just those rows. The backend
 * only ever touches rows in `failed` and dispatch is idempotent, so a recipient that already
 * succeeded is never re-sent.
 *
 * Shared by the broadcast detail page and the recipients page so retrying behaves identically
 * wherever a failed recipient is visible.
 */
const retryRecipients = ({
  broadcastId,
  recipientIds = null,
  failedCount = 0,
  setLoading = () => {},
  onDone
}) => {
  const many = !recipientIds
  const count = many ? failedCount : recipientIds.length
  Modal.confirm({
    title: many
      ? `Retry ${count} failed recipient${count === 1 ? '' : 's'}?`
      : 'Retry this recipient?',
    icon: <RedoOutlined />,
    content: (
      <p>
        The message will be requeued and re-sent to{' '}
        {many ? 'every failed recipient' : 'this recipient'}. Recipients that already succeeded
        are not affected.
      </p>
    ),
    okText: 'Retry',
    onOk: async () => {
      const res = await postRequest(
        dutyBroadcastRetryRecipientsUrl(broadcastId),
        recipientIds ? { recipient_ids: recipientIds } : {},
        'retry',
        setLoading
      )
      if (res.success) {
        message.success(`Requeued ${res.data.requeued} recipient(s)`)
        if (onDone) onDone()
      } else if (res.error && res.error.response) {
        message.error(res.error.response.data.detail || 'Could not retry.')
      }
    }
  })
}

export default retryRecipients
